"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const BodyRegionsIcon_1 = require("../BodyRegionsIcon/");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
const storage_1 = require("@completeanatomy/storage");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const ModelsPanel_1 = __importDefault(require("../../organisms/ModelsPanel"));
const ModelSexOverlay_1 = __importDefault(require("../ModelSexOverlay"));
const STORAGE_KEY = 'isModelPanelOpenedFirstTime';
function BodyRegionsButton({ className, disabled }) {
    const storage = (0, storage_1.useStorageService)();
    const bridge = (0, bridge_1.useBridge)();
    const [performingButton, setPerformingButton] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [params] = (0, react_router_dom_1.useSearchParams)();
    const modelType = (0, models_1.useModelType)();
    const ref = (0, react_1.useRef)(modelType);
    const [isModelSexOverlayVisible, setIsModelSexOverlayVisible] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const exec = () => __awaiter(this, void 0, void 0, function* () {
            const wasOpenedFirstTime = yield (storage === null || storage === void 0 ? void 0 : storage.get(STORAGE_KEY));
            if (!wasOpenedFirstTime) {
                setIsOpen(true);
                storage === null || storage === void 0 ? void 0 : storage.put(STORAGE_KEY, true);
            }
        });
        /**
         * @todo Temporary hack until Hub is migrated to ca-modules
         */
        if (params.get('shouldOpenModelsPanel')) {
            exec();
        }
    }, [storage, params]);
    const modelSexChanged = (0, react_1.useCallback)(() => {
        if (modelType === bridge_schema_1.ModelType.Male || modelType === bridge_schema_1.ModelType.Female) {
            setIsModelSexOverlayVisible(true);
            setTimeout(() => {
                setIsModelSexOverlayVisible(false);
            }, 2000);
        }
    }, [modelType, setIsModelSexOverlayVisible]);
    const onClick = (0, react_1.useCallback)((type) => {
        var _a;
        if (disabled) {
            return;
        }
        switch (type) {
            case ui_1.ActionType.SINGLE_CLICK:
                setIsOpen(!isOpen);
                break;
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingButton(true);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingButton(false);
                break;
            case ui_1.ActionType.LONG_CLICK:
                // @ts-expect-error — @todo replace when tools are implemented in ReUI
                (_a = window.clearAllTools) === null || _a === void 0 ? void 0 : _a.call(window, { isDetailed: false });
                bridge === null || bridge === void 0 ? void 0 : bridge.toggleModelSex();
                break;
        }
    }, [bridge, disabled, isOpen]);
    (0, react_1.useEffect)(() => {
        if (ref.current !== modelType) {
            modelSexChanged();
            ref.current = modelType;
        }
    }, [modelSexChanged, modelType, onClick]);
    const [buttonHandlers] = (0, ui_1.useLongPressHandlers)(onClick);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ModelsPanel_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, "data-e2e": 'BodyRegionsButton_ModelsPanel' }), (0, jsx_runtime_1.jsx)(ModelSexOverlay_1.default, { isShown: isModelSexOverlayVisible, "data-e2e": 'BodyRegionsButton_ModelSexOverlay' }), (0, jsx_runtime_1.jsxs)(Container, Object.assign({ "$disabled": disabled, className: className, "aria-label": "models-button", "$performingMouseDown": performingButton }, buttonHandlers, { "data-e2e": 'BodyRegionsButton_Container', children: [(0, jsx_runtime_1.jsx)(BodyRegionsIcon_1.BodyRegionsIcon, { "data-e2e": 'BodyRegionsButton_BodyRegionsIcon' }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'BodyRegionsButton_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.models) })] }))] }));
}
exports.default = (0, storage_1.withStorageProvider)(BodyRegionsButton);
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;

  box-sizing: border-box;
  min-width: 70px;
  height: 80px;
  margin-right: 0;
  padding-top: 8px;
  padding-bottom: 10px;

  text-align: center;

  border-color: ${({ theme }) => theme.questions.edit.disabledBackground};
  border-style: solid;
  border-width: 1px 1px 0 0;

  ${({ $disabled }) => (0, styled_components_1.css) `
    opacity: ${$disabled ? 0.8 : 1};
    cursor: ${$disabled ? 'default' : 'pointer'};
  `};

  transform: scale(
    ${({ $performingMouseDown }) => ($performingMouseDown ? 0.9 : 1)}
  );

  transition: transform 0.125s ease-in-out, opacity 0.2s ease-in-out;

  user-select: none;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    justify-content: flex-end;

    min-width: 80px;
    height: inherit;
    margin-top: 8px;
    margin-right: 10px;
    padding-top: 0;
    padding-bottom: 0;

    border-width: 0;

    &::after {
      position: absolute;
      top: 10%;
      right: -5px;

      display: initial;
      width: 1px;
      height: 80%;

      background: #5c656c;
      opacity: 0.2;
      transition: opacity 0.1s ease-in-out;

      content: '';
    }
  `)}

  ${ui_1.deviceLandscape.mobileS((0, styled_components_1.css) `
    padding-bottom: 12px;

    &::after {
      display: none;
    }
  `)}
`;
const Title = styled_components_1.default.div `
  margin: 5px 0 3px;

  color: ${({ theme }) => theme.textSecondary};

  font-size: 13px;
  line-height: 1em;

  transition: color 2s cubic-bezier(1, -0.4, 0.8, 1);

  ${ui_1.device.tablet((0, styled_components_1.css) `
    font-size: 11px;
  `)}
`;
